import styled from 'styled-components';

export const FooterContainer = styled.div`
  background-color: #100404;
  height: 100px;
`;

